// extracted by mini-css-extract-plugin
module.exports = {"buttonImportar":"createSimcard_buttonImportar__4ULoL"};